<div class="box-content-sm report">
  <mat-card class="mat-elevation-z8" fxLayout="column" fxLayoutGap="10px">
    <mat-card-content fxLayout="column" fxLayoutGap="10px">
      <menu-header [menuTopic]="historyTopic"></menu-header>

      <mat-divider></mat-divider>
      <div fxLayout="column" fxLayoutAlign="start strech" fxLayoutGap="10px">
        <div fxLayout="row" fxLayoutAlign="space-between center">
          <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
            <mat-form-field appearance="outline">
              <mat-label>{{
                "view_value.baseline_name" | translate
              }}</mat-label>
              <mat-select [(ngModel)]="groupNameSelected">
                <mat-option *ngFor="let item of groupNameList" [value]="item">
                  {{ item }}
                </mat-option>
              </mat-select>
            </mat-form-field>
            <mat-form-field fxFlex="300px" appearance="outline">
              <mat-label>{{ "view_value.search" | translate }}</mat-label>
              <input matInput (keyup)="applyFilter($event)" #inputFilter />
            </mat-form-field>
          </div>
          <div style="padding-bottom: 1.34375em">
            <button
              [disabled]="!onDownload"
              [ngClass]="{ 'btn-primary': onDownload === true }"
              mat-stroked-button
              (click)="onExportCSV()"
              fxHide
              fxShow.gt-sm
            >
              <mat-icon>download</mat-icon>Export CSV
            </button>
          </div>
        </div>
        <div style="overflow: auto; border-radius: 10px">
          <table mat-table [dataSource]="dataSource" matSort class="hearder">
            <ng-container matColumnDef="no">
              <th mat-header-cell *matHeaderCellDef>
                {{ "view_value.no" | translate }}
              </th>
              <td mat-cell *matCellDef="let element; let i = index">
                {{
                  pageEvent
                    ? pageEvent.pageSize * pageEvent.pageIndex + i + 1
                    : i + 1
                }}
              </td>
            </ng-container>

            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ "view_value.name" | translate }}
              </th>
              <td mat-cell *matCellDef="let element; let i = index">
                {{ element.name }}
              </td>
            </ng-container>

            <ng-container matColumnDef="message">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ "view_value.message" | translate }}
              </th>
              <td mat-cell *matCellDef="let element; let i = index">
                {{ element.message }}
              </td>
            </ng-container>

            <ng-container matColumnDef="setpoint_value">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ "view_value.setpoint_value" | translate }}
              </th>
              <td mat-cell *matCellDef="let element; let i = index">
                {{ element.setpoint_value }}
              </td>
            </ng-container>

            <ng-container matColumnDef="time">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ "view_value.time" | translate }}
              </th>
              <td mat-cell *matCellDef="let element; let i = index">
                {{ element.time | date: "d/M/yyyy H:mm:ss" }}
              </td>
            </ng-container>

            <ng-container matColumnDef="type">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ "view_value.type" | translate }}
              </th>
              <td mat-cell *matCellDef="let element; let i = index">
                {{ element.type }}
              </td>
            </ng-container>

            <ng-container matColumnDef="value">
              <th mat-header-cell *matHeaderCellDef mat-sort-header>
                {{ "view_value.value" | translate }}
              </th>
              <td mat-cell *matCellDef="let element; let i = index">
                {{ element.value }}
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

            <!-- Row shown when there is no matching data. -->
            <!-- <tr class="mat-row" *matNoDataRow>
              <td class="mat-cell" [attr.colspan]="displayedColumns.length">
                {{ "report.nodatasearch" | translate }}
                {{ inputFilter.value ? '"' + inputFilter.value + '"' : "" }}
              </td>
            </tr> -->

            <tr class="mat-row no-data-row" *matNoDataRow>
              <td class="mat-cell" [attr.colspan]="displayedColumns.length">
                <div class="no-data-container">
                  <mat-icon class="no-data-icon">inbox</mat-icon>
                  <p>{{ "view_value.no_data" | translate }}</p>
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
      <mat-paginator
        [length]="length"
        [pageSize]="pageSize"
        [pageSizeOptions]="pageSizeOptions"
        (page)="pageEvent = $event"
        aria-label="Select page"
        class="paginator"
      >
      </mat-paginator>
    </mat-card-content>
  </mat-card>
</div>
